export default "__VITE_ASSET__5b8bb3df__"